import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const updatePpeComponentQuery = (data) => {
    const { componentId } = data;
    delete data.ComponentId;
  return axios.put(`${apiurl?.updatePpeComponent}/${componentId}`, data);
};

const updatePpeComponent = () => {
  const queryClient = useQueryClient();
  return useMutation(updatePpeComponentQuery, {
    onSuccess: () => {
      showAlert('PPE Component Updated Successfully!', 'success');
      queryClient.invalidateQueries('getPpeComponentList');
    },
    onError: (error) => {
      showAlert(error?.response?.data, 'error');
    }
  });
};

export default updatePpeComponent;
